export default __webpack_public_path__ + "static/media/scannedIcon.a1025c46.svg";